import { useMemo } from 'react';

import { MediaClient } from '@atlaskit/media-client';
import type { MediaClientConfig } from '@atlaskit/media-client';

import { useAuthProvider } from './useAuthProvider';

export type UseMediaClientConfig = {
	contentId: string | undefined;
	onMediaSessionError?: (err: Error) => void;
	config?: Partial<MediaClientConfig>;
};

const defaultMediaClientConfig: Partial<MediaClientConfig> = {
	useSha256ForUploads: true,
};

export const useMediaClient = ({
	contentId,
	onMediaSessionError,
	config,
}: UseMediaClientConfig) => {
	const authProvider = useAuthProvider({ contentId, onMediaSessionError });

	return useMemo(() => {
		if (!authProvider) {
			return null;
		}

		const mediaClientConfig: MediaClientConfig = {
			authProvider,
			...defaultMediaClientConfig,
			...config,
		};

		return new MediaClient(mediaClientConfig);
	}, [authProvider, config]);
};
